import { jsx as p, jsxs as C } from "react/jsx-runtime";
import { c as I } from "react/compiler-runtime";
import { TextField as T, InputAdornment as g, Box as v } from "@mui/material";
import B from "@mui/icons-material/Search";
import { useState as P } from "react";
import { debounce as V } from "lodash";
import { u as j } from "../../../chunks/TableContext.js";
import { styles as x } from "./styles.js";
function q() {
  const e = I(12), {
    searchPlaceholder: f,
    defaultSearchValue: S,
    onSearchChange: s,
    searchLeftComponent: r,
    disableTableSearch: o
  } = j(), c = f === void 0 ? "Search..." : f, [i, b] = P(S ?? "");
  let a;
  e[0] !== s ? (a = V((m) => {
    s?.(m);
  }, 300), e[0] = s, e[1] = a) : a = e[1];
  const h = a;
  let n;
  e[2] !== h ? (n = (m) => {
    const d = m.target.value;
    b(d), h(d);
  }, e[2] = h, e[3] = n) : n = e[3];
  const u = n;
  if (o && !r)
    return null;
  let t;
  e[4] !== o || e[5] !== u || e[6] !== i || e[7] !== c ? (t = !o && /* @__PURE__ */ p(T, { placeholder: c, value: i, onChange: u, InputProps: {
    startAdornment: /* @__PURE__ */ p(g, { position: "start", children: /* @__PURE__ */ p(B, { sx: {
      fontSize: "16px"
    } }) })
  }, sx: x.tableSearchTextField }), e[4] = o, e[5] = u, e[6] = i, e[7] = c, e[8] = t) : t = e[8];
  let l;
  return e[9] !== r || e[10] !== t ? (l = /* @__PURE__ */ C(v, { sx: x.searchBarContainer, children: [
    r,
    t
  ] }), e[9] = r, e[10] = t, e[11] = l) : l = e[11], l;
}
export {
  q as TableSearchBar
};
